import { actionTypeCommon } from "../types";
import { ApiService } from "../../config";
// import { setCache, getCache } from './actionCache';
// import { Commons } from "../../utilities";

export const getLanguages = () => async (dispatch) => {
    dispatch({ type: actionTypeCommon.GET_LANGUAGES_REQUEST });
    try {
        const response = await ApiService.get(`/api/languages`);
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.GET_LANGUAGES_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeCommon.GET_LANGUAGES_FAILURE,
            payload: errorPayload,
        });
    }
};

// export const getLanguages = () => async (dispatch, getState) => {
//     const state = getState();
//     const cachedData = getCache(state, 'languages', 300000); // 5-minute cache duration

//     if (cachedData) {
//         dispatch({
//             type: actionTypeCommon.GET_LANGUAGES_SUCCESS,
//             payload: cachedData,
//         });
//         return;
//     }

//     dispatch({ type: actionTypeCommon.GET_LANGUAGES_REQUEST });
//     try {
//         const response = await ApiService.get(`/api/languages`);
//         const responsePayload = {
//             data: response.data,
//             status: response.status,
//         };

//         // Cache the response
//         dispatch(setCache('languages', responsePayload));
//         dispatch({
//             type: actionTypeCommon.GET_LANGUAGES_SUCCESS,
//             payload: responsePayload,
//         });
//     } catch (error) {
//         const errorPayload = {
//             status: error.response?.status,
//             data: error.response?.data,
//         };
//         dispatch({
//             type: actionTypeCommon.GET_LANGUAGES_FAILURE,
//             payload: errorPayload,
//         });
//     }
// };

export const getCountry = () => async (dispatch) => {
    dispatch({ type: actionTypeCommon.GET_COUNTRY_REQUEST });
    try {
        const response = await ApiService.get(`/api/GetCountry`);
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.GET_COUNTRY_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeCommon.GET_COUNTRY_FAILURE,
            payload: errorPayload,
        });
    }
};

// export const getCountry = () => async (dispatch, getState) => {
//     const state = getState();
//     const cachedData = getCache(state, 'country', 300000); // 5-minute cache duration

//     if (cachedData) {
//         dispatch({
//             type: actionTypeCommon.GET_COUNTRY_SUCCESS,
//             payload: cachedData,
//         });
//         return;
//     }

//     dispatch({ type: actionTypeCommon.GET_COUNTRY_REQUEST });
//     try {
//         const response = await ApiService.get(`/api/GetCountry`);
//         const responsePayload = {
//             data: response.data,
//             status: response.status,
//         };

//         // Cache the response
//         dispatch(setCache('country', responsePayload));
//         dispatch({
//             type: actionTypeCommon.GET_COUNTRY_SUCCESS,
//             payload: responsePayload,
//         });
//     } catch (error) {
//         const errorPayload = {
//             status: error.response?.status,
//             data: error.response?.data,
//         };
//         dispatch({
//             type: actionTypeCommon.GET_COUNTRY_FAILURE,
//             payload: errorPayload,
//         });
//     }
// };

export const getTimeZones = () => async (dispatch) => {
    dispatch({ type: actionTypeCommon.GET_TIME_ZONES_REQUEST });
    try {
        const response = await ApiService.get(`/api/gettimezones`);
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.GET_TIME_ZONES_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeCommon.GET_TIME_ZONES_FAILURE,
            payload: errorPayload,
        });
    }
};

// export const getTimeZones = () => async (dispatch, getState) => {
//     const state = getState();
//     const cachedData = getCache(state, 'timezones', 300000); // 5-minute cache duration

//     if (cachedData) {
//         dispatch({
//             type: actionTypeCommon.GET_TIME_ZONES_SUCCESS,
//             payload: cachedData,
//         });
//         return;
//     }

//     dispatch({ type: actionTypeCommon.GET_TIME_ZONES_REQUEST });
//     try {
//         const response = await ApiService.get(`/api/gettimezones`);
//         const responsePayload = {
//             data: response.data,
//             status: response.status,
//         };

//         // Cache the response
//         dispatch(setCache('timezones', responsePayload));
//         dispatch({
//             type: actionTypeCommon.GET_TIME_ZONES_SUCCESS,
//             payload: responsePayload,
//         });
//     } catch (error) {
//         const errorPayload = {
//             status: error.response?.status,
//             data: error.response?.data,
//         };
//         dispatch({
//             type: actionTypeCommon.GET_TIME_ZONES_FAILURE,
//             payload: errorPayload,
//         });
//     }
// };

export const getWebsiteLanguageData = () => async (dispatch) => {
    dispatch({ type: actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_REQUEST });
    try {
        const response = await ApiService.get(`/api/websiteLanguages`);
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_FAILURE,
            payload: errorPayload,
        });
    }
};

// export const getWebsiteLanguageData = () => async (dispatch, getState) => {
//     const state = getState();
//     const cachedData = getCache(state, 'websiteLanguageData', 300000); // 5-minute cache duration

//     if (cachedData) {
//         dispatch({
//             type: actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_SUCCESS,
//             payload: cachedData,
//         });
//         return;
//     }

//     dispatch({ type: actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_REQUEST });
//     try {
//         const response = await ApiService.get(`/api/websiteLanguages`);
//         const responsePayload = {
//             data: response.data,
//             status: response.status,
//         };

//         // Cache the response
//         dispatch(setCache('websiteLanguageData', responsePayload));
//         dispatch({
//             type: actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_SUCCESS,
//             payload: responsePayload,
//         });
//     } catch (error) {
//         const errorPayload = {
//             status: error.response?.status,
//             data: error.response?.data,
//         };
//         dispatch({
//             type: actionTypeCommon.GET_WEBSITE_LANGUAGE_DATA_FAILURE,
//             payload: errorPayload,
//         });
//     }
// };

export const getCurrency = () => async (dispatch) => {
    dispatch({ type: actionTypeCommon.GET_CURRENCY_REQUEST });
    try {
        const response = await ApiService.get(`/api/getcurrency`);
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.GET_CURRENCY_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeCommon.GET_CURRENCY_FAILURE,
            payload: errorPayload,
        });
    }
};

// export const getCurrency = () => async (dispatch, getState) => {
//     const state = getState();
//     const cachedData = getCache(state, 'currency', 300000); // 5-minute cache duration

//     if (cachedData) {
//         dispatch({
//             type: actionTypeCommon.GET_CURRENCY_SUCCESS,
//             payload: cachedData,
//         });
//         return;
//     }

//     dispatch({ type: actionTypeCommon.GET_CURRENCY_REQUEST });
//     try {
//         const response = await ApiService.get(`/api/getcurrency`);
//         const responsePayload = {
//             data: response.data,
//             status: response.status,
//         };

//         // Cache the response
//         dispatch(setCache('currency', responsePayload));
//         dispatch({
//             type: actionTypeCommon.GET_CURRENCY_SUCCESS,
//             payload: responsePayload,
//         });
//     } catch (error) {
//         const errorPayload = {
//             status: error.response?.status,
//             data: error.response?.data,
//         };
//         dispatch({
//             type: actionTypeCommon.GET_CURRENCY_FAILURE,
//             payload: errorPayload,
//         });
//     }
// };

export const getPhysicianService = (languageId) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.GET_PHYSICIAN_SERVICE_REQUEST });
    try {
        const response = await ApiService.get(
            `/doctor/physicianService/?languageId=${languageId}`
        );
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.GET_PHYSICIAN_SERVICE_SUCCESS,
            payload: responsePayload,
        });
    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeCommon.GET_PHYSICIAN_SERVICE_FAILURE,
            payload: errorPayload,
        });
    }
};

// export const getPhysicianService = (languageId) => async (dispatch, getState) => {
//     const state = getState();
//     const cacheKey = `physicianService_${languageId}`;
//     const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//     if (cachedData) {
//         dispatch({
//             type: actionTypeCommon.GET_PHYSICIAN_SERVICE_SUCCESS,
//             payload: cachedData,
//         });
//         return;
//     }

//     dispatch({ type: actionTypeCommon.GET_PHYSICIAN_SERVICE_REQUEST });
//     try {
//         const response = await ApiService.get(`/doctor/physicianService/?languageId=${languageId}`);
//         const responsePayload = {
//             data: response.data,
//             status: response.status,
//         };

//         // Cache the response
//         dispatch(setCache(cacheKey, responsePayload));
//         dispatch({
//             type: actionTypeCommon.GET_PHYSICIAN_SERVICE_SUCCESS,
//             payload: responsePayload,
//         });
//     } catch (error) {
//         const errorPayload = {
//             status: error.response?.status,
//             data: error.response?.data,
//         };
//         dispatch({
//             type: actionTypeCommon.GET_PHYSICIAN_SERVICE_FAILURE,
//             payload: errorPayload,
//         });
//     }
// };

export const registerUser = (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_REGISTER_USER_REQUEST });
    try {
        const response = await ApiService.post(
            "/auth/signup",
            JSON.stringify(credentials)
        );

        dispatch({
            type: actionTypeCommon.POST_REGISTER_USER_SUCCESS,
            payload: response,
        });
        if (callback) {
            callback(null, response);
        }
    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_REGISTER_USER_FAILURE,
            payload: error,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
};
export const verifyOtp = (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_VERIFY_OTP_REQUEST });
    try {
        const response = await ApiService.post("/auth/verifyotp", credentials);
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.POST_VERIFY_OTP_SUCCESS,
            payload: responsePayload,
        });
        if (callback) {
            callback(null, responsePayload);
        }
    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_VERIFY_OTP_FAILURE,
            payload: error.response,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
};
export const signIn = (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_SIGN_IN_REQUEST });
    try {
        const response = await ApiService.post(
            "/auth/signin",
            JSON.stringify(credentials)
        );
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.POST_SIGN_IN_SUCCESS,
            payload: responsePayload,
        });
        if (callback) {
            callback(null, responsePayload);
        }
    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_SIGN_IN_FAILURE,
            payload: error.response,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
};
export const forgotPassword = (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_FORGOT_PASSWORD_REQUEST });
    try {
        const response = await ApiService.post(
            "/auth/forgotpassword",
            JSON.stringify(credentials)
        );
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.POST_FORGOT_PASSWORD_SUCCESS,
            payload: responsePayload,
        });
        if (callback) {
            callback(null, responsePayload);
        }
    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_FORGOT_PASSWORD_FAILURE,
            payload: error.response,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
};

export const changePassword = (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_CHANGE_PASSWORD_REQUEST });
    try {
        const response = await ApiService.post(
            "/auth/changepassword",
            JSON.stringify(credentials)
        );
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.POST_CHANGE_PASSWORD_SUCCESS,
            payload: responsePayload,
        });
        if (callback) {
            callback(null, responsePayload);
        }
    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_CHANGE_PASSWORD_FAILURE,
            payload: error.response,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
};
export const profileImage = (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_PROFILE_IMAGE_REQUEST });
    try {
        const response = await ApiService.post("/doctor/profileimage", credentials);
        const responsePayload = {
            data: response.data,
            status: response.status,
        };
        dispatch({
            type: actionTypeCommon.POST_PROFILE_IMAGE_SUCCESS,
            payload: responsePayload,
        });
        if (callback) {
            callback(null, responsePayload);
        }
    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_PROFILE_IMAGE_FAILURE,
            payload: error.response,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
};

export const uploadPdf = (formData, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_UPLOAD_PDF_REQUEST });
    try {
        const response = await ApiService.post("/api/uploadPdf", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        dispatch({
            type: actionTypeCommon.POST_UPLOAD_PDF_SUCCESS,
            payload: response,
        });
        if (callback) {
            callback(null, response);
        }
    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_UPLOAD_PDF_FAILURE,
            payload: error,
        });
        if (callback) {
            callback(error.response, null);
        }
    }
};

export const postGetAuthToken = (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeCommon.POST_API_GET_AUTH_TOKEN_REQUEST });
    try {
        const response = await ApiService.post(
            "/api/GetAuthToken",
            JSON.stringify(credentials)
        );
        const responsePayload = {
            data: response.data,
            status: response.status,
        };

        dispatch({
            type: actionTypeCommon.POST_API_GET_AUTH_TOKEN_SUCCESS,
            payload: responsePayload,
        });

        if (callback) {
            callback(null, response);
        }

    } catch (error) {
        dispatch({
            type: actionTypeCommon.POST_CHANGE_PASSWORD_FAILURE,
            payload: error.response,
        });

        if (callback) {
            callback(error.response, null);
        }
    }
};

export const logout = () => {
    return (dispatch) => {
        dispatch({ type: "LOGOUT" });
        localStorage.removeItem("doctor_access");
    };
};

const actionCommon = {
    getLanguages,
    getCountry,
    getTimeZones,
    getWebsiteLanguageData,
    getCurrency,
    getPhysicianService,
    registerUser,
    verifyOtp,
    signIn,
    forgotPassword,
    changePassword,
    profileImage,
    uploadPdf,
    postGetAuthToken,
    logout,
};
export default actionCommon;
